import { List, Flex, Text } from "@mantine/core";
import { BusinessHour } from "../../types";

export const BusinessHourItem = ({ day, hours }: BusinessHour) => (
  <List.Item>
    <Flex key={day} justify={"space-between"}>
      <Text size="sm" c="dimmed" style={{ minWidth: "100px" }}>
        {day}
      </Text>
      <Text size="sm" c="dimmed">
        {hours}
      </Text>
    </Flex>
  </List.Item>
);
